export default {
    routerJudge: (urldata) => {
        let urlList = [
            "/login",
            "/OpenPay",
            "/WxQuery",
            "/OpenCard",
            "/VnoWxQuery",
            "/VnoOpenPay",
            "/QRcodeVideo",
            "/VnoOpenCard",
            "/UniversalPay",
            "/realNameLink",
            "/OpenCardMessage",
            "/realNameLinkForm",
            "/realNameLinkError",
            "/realNameLinkSuccess",
            "/DxWithoutCodeLogin24af2192e12d490cbdb899729fcfc010",
            "/YhWithoutCodeLogin7f00f1f345874528af99d77ed877748b",
            "/YyWithoutCodeLogin1dd955d4f93d4743a972ee639f94f843",
            "/ZnWithoutCodeLogin284e92113c5e4391a689f4807cd9b0b6",
            "/ZyWithoutCodeLogina7f66fd4a61a4f18b76ead9c8a82177a",
            "/SwWithoutCodeLogin3e86ae1e87084e5ca4028a42c6191b71",
            "/phWithoutCodeLogin3ae42313a1324d9ea16e3daf081ff6e1",
            "/CyWithoutCodeLoginb2bcafdbf2c34d1d8d94e328630d2e24",
            "/HgxhWithoutCodeLogin4c4d3b34f5ec417dbdb1d20dd98b4d",
        ];
        let stringExists = urlList.includes(urldata);
        return stringExists
    }
}
